import React, { useReducer } from 'react';
import TeacherContext from "./teacherContext";
import TeacherReducer from "./teacherReducer";
import axiosClient from '../../config/axiosClient';

import {
    AGREGAR_TEACHER,
    OBTENER_TEACHER,
    LISTA_TEACHERS,
    MATCH_TEACHER,
    ERROR_TEACHER
} from "../../types";

const TeacherState = (props) => {
    const initialState = {
        teacher: {},
        allTeachers: [],
        studentsFromTeacher: [],
        errorResult: false,
        msg: null
    }
    
    //  Crear Dispatch y State
    const [ state, dispatch ] = useReducer( TeacherReducer, initialState );

    //  Crear las Funciones
    const agregarTeacher = async mentor => {
        try {
            const resultado = await axiosClient.post('/api/teacher', mentor);
            dispatch({
                type: AGREGAR_TEACHER,
                payload: resultado.data
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.msg,
                categoria: 'alerta-error'
            }
            dispatch({
                type: ERROR_TEACHER,
                payload: alerta
            })
        }
    }

    //  Obtener los Reportes de un Profile
    const obtenerTeacher = async () => {
        const resultado = await axiosClient.get('/api/teacher');
        try {
            dispatch({
                type: OBTENER_TEACHER,
                payload: resultado.data
            })
        } catch (error) { }
    }

    const listarTeachers = async() => {
        const resultado = await axiosClient.get('/api/teacher/allTeachers');
        try {
            dispatch({
                type: LISTA_TEACHERS,
                payload: resultado.data.results
            })
        } catch (error) { console.log(error); }
    }

    const matchFromTeacher = async() => {
        const resultado = await axiosClient.get('/api/teacher/getMatch');
        try {
            dispatch({
                type: MATCH_TEACHER,
                payload: resultado.data.students
            })
        } catch (error) { console.log(error); }
    }

    return (
        <TeacherContext.Provider
            value={{
                teacher: state.teacher,
                allTeachers: state.allTeachers,
                studentsFromTeacher: state.studentsFromTeacher,
                errorResult: state.errorResult,
                msg: state.msg,
                agregarTeacher,
                obtenerTeacher,
                listarTeachers,
                matchFromTeacher
            }}
        >
            {props.children}
        </TeacherContext.Provider>
    )
};

export default TeacherState;